// import JSZip from "jszip";
// import * as tus from "tus-js-client";
import { errorMessages } from "./components/errorBoundary/ErrorMessages";
export function getAccessToken() {
  try {
    const token = localStorage.getItem("token");
    if (!token) {
      throw new Error("noTokenFound");
    }
    return token;
  } catch (error) {
    throw error;
  }
}

export function isUUID(str) {
  const uuidPattern =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  return uuidPattern.test(str);
}

export const isOptValInArr = (arr, optVal) =>
  // if(!arr) return false;
  arr.find((itm) => itm === optVal) ? true : false;
// console.log("utilss usedd");
// arr.find((item) => {
//     if(item === optVal) {
//         console.log("something true");
//         return true;
//     } else {
//         return false;
//     }
// })

// export async function zip(files) {
//   const zip = new JSZip();

//   // Iterate through each selected file and add it to the zip file
//   for (let i = 0; i < files.length; i++) {
//     const file = files[i];
//     zip.file(files[i].name, file);
//   }

//   // Generate the zip file asynchronously
//   return await zip.generateAsync({ type: "blob" });
// }

// export async function sendDataTusd(filePath, metastruct) {
//   // specify the URL of your tusd server
//   const serverUrl = "http://15.207.84.50:1080/files/";

//   // specify the path to the file you want to upload

//   // Set Authorization headers if it is required by the tus server.
//   const headers = {
//     Authorization: "Bearer " + getAccessToken(),
//   };

//   // Create a new TusUpload instance with the specified file path and server URL.
// const upload = new tus.Upload(filePath, {
//     endpoint: serverUrl,
//     chunkSize: 10000,
//     headers,
//     metadata: metastruct,
//     onProgress: (bytesUploaded, bytesTotal) => {
//         const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
//         console.log(bytesUploaded, bytesTotal, percentage + "%");
//     },
//     onError: (error) => {
//         console.log("Failed because: " + error);
//     },
//     onSuccess: () => {
//         console.log("Upload finished");
//     },
// });

//   // Start the upload.
//   upload.start();
// }

// export async function sendDataTusd(filePath, metastruct) {
//     // specify the URL of your tusd server
//     const serverUrl = "https://data-ingestion.wadhwaniai.org/files/";

//   // specify the path to the file you want to upload

//   // Set Authorization headers if it is required by the tus server.
//     const headers = {
//         Authorization: "Bearer " + getAccessToken(),
//     };

//     const upload = new tus.Upload(filePath, {
//         endpoint: serverUrl,
//         chunkSize: 100000,
//         headers,
//         metadata: metastruct,
//         uploadUrl: serverUrl,
//         state: false,
//         onProgress: (bytesUploaded, bytesTotal) => {
//             const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
//             console.log(bytesUploaded, bytesTotal, percentage + "%");
//         },
//         onError: (error) => {
//             console.log("Failed because: " + error);

//         },
//         onSuccess: () => {
//             window.removeEventListener("online",()=>{});
//             console.log("Upload finished");

//         },
//     });

//     const handleOnline = () => {
//       console.log(upload);
//         console.log("Internet connection restored. Resuming upload...");
//         upload.findPreviousUploads().then(function (previousUploads) {
//             // Found previous uploads so we select the first one.
//             if (previousUploads.length) {
//                 var chosenUpload = previousUploads[0];

//   // If an upload has been chosen to be resumed, instruct the upload object to do so.
//               console.log(upload._offset, upload._size);
//                 if (upload._offset !== upload._size) {
//                     upload.start();
//                 }
//             }
//             // Start the upload

//         })
//     };
//     const handleOffline = () => {
//       console.log(upload);
//       upload.findPreviousUploads().then(data => {
//         console.log(data);
//         window.removeEventListener("offline", ()=>{});
//       });
//     };
//     window.addEventListener("online", handleOnline);
//     window.addEventListener("offline", handleOffline);
//     upload.start();
// }

// export async function sendDataTusd(filePath, metastruct) {
//   const client = new tus.Upload();
//   const serverUrl = "https://data-ingestion.wadhwaniai.org/files/";

//   // Set the Tus server endpoint
//   const endpoint = "https://example.com/files";
//   // Set the file to be uploaded
//   // Set options for the Tus client
//   const upload = new tus.Upload(filePath, {
//     endpoint: serverUrl,
//     metadata: metastruct,
//     // Other Tus options...
//     onError: function (error) {
//       console.log("Error", error);
//       // Handle the error and retry the upload if the error is related to a connection issue
//       if (!navigator.onLine) {
//         console.log("Offline mode");
//         // Handle the offline state here, e.g., showing an error message or saving the upload state
//       } else {
//         console.log("Retry upload");
//         upload.start();
//       }
//     },
//     onProgress: function (bytesUploaded, bytesTotal) {
//       const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
//       console.log("Progres", percentage + "%");
//     },
//   });
//   // Start the upload
//   upload.start();
// }

function askToResumeUpload(previousUploads) {
  if (previousUploads.length === 0) return null;

  var text = "You tried to upload this file previously at these times:\n\n";
  previousUploads.forEach((previousUpload, index) => {
    text += "[" + index + "] " + previousUpload.creationTime + "\n";
  });
  text +=
    "\nEnter the corresponding number to resume an upload or press Cancel to start a new upload";

  var answer = prompt(text);
  var index = parseInt(answer, 10);

  if (!isNaN(index) && previousUploads[index]) {
    return previousUploads[index];
  }
}
export function dataURItoFile(dataURI, fileName) {
  try {
    var byteString = atob(dataURI.split(",")[1]);
    var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    const tmpBlob = new Blob([ab], { type: mimeString });
    return new File([tmpBlob], fileName, {
      type: "image/jpeg",
    });
  } catch {
    return null;
  }
}
export function filesToBase64(files) {
  const promises = files.map((fileItm) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = function () {
        const base64String = reader.result;
        resolve({ file: base64String, name: fileItm.name });
      };
      reader.onerror = function (error) {
        reject(error);
      };
      reader.readAsDataURL(new Blob([fileItm], { type: fileItm.type }));
    });
  });
  return Promise.all(promises);
}

// export async function sendDataTusd(filePath, metastruct) {
//     // Specify the URL of your tusd server.
//     const serverUrl = "http://15.207.84.50:1080/files/";

//     // Set Authorization headers if it is required by the tus server.
//     const headers = {
//       Authorization: "Bearer " + getAccessToken(),
//     };

//     // Retrieve the stored upload URL and offset from your storage mechanism
//     // where you store the upload's state.
//     const storedUploadURL = retrieveStoredUploadURL();
//     const storedOffset = retrieveStoredOffset();

//     let retryCount = 0;
//     const maxRetries = 10;

//     const startUpload = () => {
//       // Create a new TusUpload instance with the specified file path and server URL.
//       const upload = new tus.Upload(filePath, {
//         endpoint: serverUrl,
//         chunkSize: 10000,
//         headers,
//         metadata: metastruct,
//         uploadUrl: storedUploadURL, // Set the stored upload URL
//         uploadSize: storedOffset, // Set the stored offset as the upload size
//         onProgress: (bytesUploaded, bytesTotal) => {
//           const percentage = ((bytesUploaded / bytesTotal) * 100).toFixed(2);
//           console.log(bytesUploaded, bytesTotal, percentage + "%");
//         },
//         onError: (error) => {
//           console.log("Failed because: " + error);
//           storeUploadState(upload.url, upload.offset);
//           if (retryCount < maxRetries) {
//             console.log("Retrying upload...");
//             retryCount++;
//             startUpload();
//           } else {
//             console.log("Maximum retry count exceeded. Upload failed.");
//           }
//         },
//         onSuccess: () => {
//           console.log("Upload finished");

//           // Clear the stored upload URL and offset as the upload is completed
//           clearStoredUploadState();
//         },
//       });

//       // Start the upload.
//       upload.start();
//     };

//     // Event listener for the 'online' event
//     const handleOnline = () => {
//       console.log("Internet connection restored. Resuming upload...");
//       startUpload();
//     };

//     startUpload();

//     // Check if the initial online status is false
//     if (!navigator.onLine) {
//       console.log("No internet connection. Waiting for connection to resume...");
//     }

//     // Event listener for the 'online' event
//     window.addEventListener("online", handleOnline);
//   }
// // Retrieve the stored upload URL from localStorage
// function retrieveStoredUploadURL() {
//     return localStorage.getItem("uploadURL");
//   }

//   // Retrieve the stored offset from localStorage
//   function retrieveStoredOffset() {
//     const offset = localStorage.getItem("uploadOffset");
//     return offset ? parseInt(offset, 10) : 0;
//   }

//   // Store the upload URL and offset in localStorage
//   function storeUploadState(uploadURL, offset) {
//     localStorage.setItem("uploadURL", uploadURL);
//     localStorage.setItem("uploadOffset", String(offset));
//   }

//   // Clear the stored upload URL and offset from localStorage
//   function clearStoredUploadState() {
//     localStorage.removeItem("uploadURL");
//     localStorage.removeItem("uploadOffset");
//   }
